module.exports = __webpack_public_path__ + "static/media/Twitter.426daa5b.svg";